module.exports = __webpack_public_path__ + "img/bar_logo_left.5107bc20.png";